import React from 'react';
import LegalLayout from '../components/LegalLayout';

const Privacy: React.FC = () => {
  return (
    <LegalLayout title="Информация о конфиденциальности" updatedAt="07.05.2026">
      <section className="space-y-4">
        <h2 className="text-xl font-semibold text-gray-900">Владелец сайта</h2>
        <p>
          Владелец сайта: ООО «ПРОТЭКО.РУС», ОГРН 1225500020866,
          ИНН 5528051933. Адрес: 646070, Омская область, Москаленский муниципальный район,
          г. п. Москаленское, рп. Москаленки, ул. Железнодорожная, д. 11.
          Email для обращений: proteko.rus@mail.ru.
        </p>
        <p>
          Настоящая страница описывает текущий режим работы именно этого сайта.
          Она не является согласием на обработку персональных данных и не содержит
          заявления о сборе персональных данных через сайт.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold text-gray-900">Сайт работает как сайт-визитка</h2>
        <p>
          На сайте размещена справочная информация о компании, продукции, доставке
          и доступных способах связи. Сайт не содержит форм, через которые посетитель
          может передать персональные данные владельцу сайта.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold text-gray-900">Персональные данные через сайт не собираются</h2>
        <p>
          В текущем режиме сайт не запрашивает, не принимает, не записывает и не хранит
          персональные данные посетителей через публичный интерфейс сайта.
        </p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>учетные записи посетителей на сайте не создаются;</li>
          <li>заявки через форму обратной связи не принимаются;</li>
          <li>заказы и состав корзины на сайте не оформляются и не сохраняются;</li>
          <li>отзывы, имена авторов, оценки, фото и видео посетителей не принимаются;</li>
          <li>cookie-баннер не используется, маркетинговые cookie на сайте не устанавливаются.</li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold text-gray-900">Самостоятельное обращение по контактам</h2>
        <p>
          Если посетитель самостоятельно переходит по ссылке для звонка, WhatsApp, Telegram
          или пишет на email, дальнейшее общение происходит по выбранному посетителем каналу
          связи и не является передачей данных через форму этого сайта.
        </p>
        <p>
          Не направляйте через мессенджеры или email сведения, которые не нужны для ответа
          на ваш вопрос. Для общих вопросов о продукции достаточно описать интересующий товар
          и удобный способ связи.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-semibold text-gray-900">Техническая работа сайта</h2>
        <p>
          Для показа страниц браузер посетителя обращается к серверу сайта. В ходе такого
          соединения сервер, хостинг, Caddy и иные инфраструктурные компоненты могут автоматически
          обрабатывать технические сведения запроса: IP-адрес, user-agent, дату и время обращения,
          запрошенный адрес страницы и служебные сведения об ошибках.
        </p>
        <p>
          Эти сведения не запрашиваются у посетителя через формы, не используются для создания
          профиля посетителя, оформления заказа, рассылок или маркетингового отслеживания.
          Они необходимы для технического показа сайта, безопасности, диагностики ошибок
          и защиты от злоупотреблений.
        </p>
        <p>
          На странице доставки используется карта Yandex Maps. При загрузке карты браузер
          может обращаться к сервисам Яндекса, работа которых регулируется документами
          соответствующего сервиса.
        </p>
      </section>

    </LegalLayout>
  );
};

export default Privacy;
